import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

export const BackSvg = ({ width = 10, height = 16, ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.56641 15.3504L0.200012 8.00001L7.56641 0.633606L9.41681 2.51681L3.93361 8.00001L9.41681 13.4832L7.56641 15.3504Z"
      fill="currentColor"
    />
  </svg>
);

export const LogoutSvg = ({ width = 16, height = 16, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
    />
    <path
      fillRule="evenodd"
      d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
    />
  </svg>
);

export const QueueSvg = ({ width = 29, height = 28, ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="5" y="6" width="18" height="2" rx="1" fill="currentColor" />
    <rect x="5" y="13" width="18" height="2" rx="1" fill="currentColor" />
    <rect x="5" y="20" width="10" height="2" rx="1" fill="currentColor" />
    <rect x="17" y="20" width="8" height="2" rx="1" fill="currentColor" />
    <rect
      x="22"
      y="17"
      width="8"
      height="2"
      rx="1"
      transform="rotate(90 22 17)"
      fill="currentColor"
    />
  </svg>
);

export const AddSvg = ({ width = 12, height = 12, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="currentColor"
    viewBox="0 0 12 12"
    {...props}
  >
    <line
      x1="6"
      y1="5.46393e-08"
      x2="6"
      y2="12"
      stroke="currentColor"
      strokeWidth="2"
    />
    <line
      x1="12"
      y1="6"
      x2="-1.0285e-07"
      y2="6"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const UsersSvg = ({ width = 24, height = 24, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width={width}
    height={height}
  >
    <path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z" />
  </svg>
);

export const SettingsSvg = ({ width = 16, height = 16, ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.48317 15.4336L5.18317 13.1168C5.18317 13.0832 5.16104 13.0555 5.11677 13.0336C5.07197 13.0112 5.03864 13 5.01677 13L2.83357 13.9168L0.316772 9.48322L2.13357 8.10002C2.14477 8.08882 2.15304 8.06935 2.15837 8.04162C2.16371 8.01388 2.16637 7.99442 2.16637 7.98322C2.16637 7.97202 2.16371 7.95548 2.15837 7.93362C2.15304 7.91122 2.14477 7.89442 2.13357 7.88322L0.316772 6.50001L2.83357 2.11681L5.01677 3.00002C5.04984 3.01122 5.08584 3.00562 5.12477 2.98322C5.16371 2.96135 5.18877 2.93362 5.19997 2.90002L5.48317 0.550415H10.5168L10.8 2.90002C10.8112 2.93362 10.8418 2.96135 10.892 2.98322C10.9416 3.00562 10.9832 3.01681 11.0168 3.01681L13.1664 2.11681L15.6832 6.50001L13.8496 7.88322C13.8389 7.89442 13.8336 7.91388 13.8336 7.94162C13.8336 7.96935 13.8336 7.98882 13.8336 8.00002C13.8336 8.01122 13.8306 8.03068 13.8248 8.05842C13.8194 8.08615 13.8277 8.10562 13.8496 8.11682L15.6832 9.48322L13.1336 13.9168L10.9504 13C10.928 12.9888 10.9 12.9971 10.8664 13.0248C10.8333 13.0525 10.8168 13.0776 10.8168 13.1L10.5168 15.4336H5.48317ZM7.93357 10.5504C8.64451 10.5504 9.2501 10.3003 9.75037 9.80002C10.2501 9.29975 10.5 8.69415 10.5 7.98322C10.5 7.28348 10.2501 6.68081 9.75037 6.17521C9.2501 5.66961 8.64451 5.41681 7.93357 5.41681C7.23331 5.41681 6.63037 5.66961 6.12477 6.17521C5.61917 6.68081 5.36637 7.28348 5.36637 7.98322C5.36637 8.69415 5.61917 9.29975 6.12477 9.80002C6.63037 10.3003 7.23331 10.5504 7.93357 10.5504Z"
      fill="currentColor"
    />
  </svg>
);

export const FlashedSvg = ({ width = 16, height = 16, ...props }: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
      fill="#FFE70D"
    />
    <path
      d="M6.8876 13.025L7.4498 9.12498H5.0372L8.5874 2.97498H9.125L8.5748 6.86238H10.9748L7.4252 13.025H6.8876Z"
      fill="#010024"
    />
  </svg>
);

export const TickedSvg = ({ width = 16, height = 16, ...props }: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
      fill="#45D27E"
    />
    <path
      d="M6.7874 11.4998L3.4124 8.12478L4.6748 6.86238L6.8126 9.01277L11.3498 4.47498L12.5876 5.70018L6.7874 11.4998Z"
      fill="#FFF"
    />
  </svg>
);

/*
const Zone = ({width = 16, height = 16, ...props}: Omit<SvgIconType, 'color'>) => (
  <Svg width={width} height={height} viewBox="0 0 16 16" fill="none" {...props}>
    <Rect width={width} height={height} rx="8" fill="#6E7891" />
    <Path d="M11 10.4642V12H5V10.4527L8.91304 5.53582H5.19282V4H10.9093V5.54728L6.98488 10.4642H11Z" fill="white" />
  </Svg>
);
*/

export const ZoneSvg = ({ width = 16, height = 16, ...props }: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" {...props}>
    <rect width={width} height={height} rx="8" fill="#6E7891" />
    <path
      d="M11 10.4642V12H5V10.4527L8.91304 5.53582H5.19282V4H10.9093V5.54728L6.98488 10.4642H11Z"
      fill="white"
    />
  </svg>
);
